import { createAction } from '@reduxjs/toolkit'

// tryGetAvailableUnits
export const getAll = createAction('get_available_units')
export const getAllSuccess = createAction<string[]>(
  'get_available_units_success'
)
export const getAllFailed = createAction('get_available_units_failed')
